import { Heading, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { TiktokIconRounded } from 'components/icons';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type TikTokAuthorizationStepProps = {};

const TikTokAuthorizationStep: React.FC<TikTokAuthorizationStepProps> = () => {
  return (
    <SocialShareModalBody showHeader={false}>
      <Spacer
        orientation="vertical"
        space="14px"
        align="center"
        justify="center"
      >
        <TiktokIconRounded width="100px" height="100px" />

        <Heading level={2} align="center">
          We'll quickly send you to TikTok so you can give us permission to add
          videos to your account.
        </Heading>
      </Spacer>
    </SocialShareModalBody>
  );
};

export default TikTokAuthorizationStep;
